import styled from 'styled-components';
import { rem } from 'polished';
import Typography from '../../../base/Typography';

export const ProductResourcesViewContainer = styled.div`
  /**  Hidden initially, then shown via javascript */
  visibility: hidden; 
  height: 0;
`;

export const TypographyResourcesViewHeadingStyled = styled(Typography)`
  && {
    padding-bottom: ${rem(35)};
  }
`;
